import React from 'react';

import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

import { mdiFileExcel } from '@mdi/js';
import SvgIcon from '@material-ui/core/SvgIcon';
import PrintIcon from '@material-ui/icons/Print';
import SearchIcon from '@material-ui/icons/Search';

import { tableTopActions, btnGroup } from './styles.css';

const checkEnter = callback => ev => ev.key === 'ENTER' && callback.call(ev);

export default function ListingSearchBar({
  loading,
  search = '',
  expansionsToggled = false,
  onSearch = Function.prototype,
  onChangeSearch = Function.prototype,
  onPrintClick = Function.prototype,
  onExportClick = Function.prototype,
  onToggleExpansion = Function.prototype,
  className,
  ...props
}) {
  return <Grid
    className={`${className} ${tableTopActions}`}
    container
    justify="space-between"
    {...props}
  >
    <Grid item>
      <TextField
        type="search"
        label="Busca"
        disabled={loading}
        value={search}
        onKeyPress={checkEnter(onSearch)}
        onChange={onChangeSearch}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: <InputAdornment>
            {
              loading
                ? <CircularProgress size={18} />
                : <IconButton onClick={onSearch}><SearchIcon /></IconButton>
            }
          </InputAdornment>
        }}
      />
    </Grid>

    <Grid item>
      <div className={btnGroup}>
        <IconButton onClick={onPrintClick}>
          <PrintIcon />
        </IconButton>

        <IconButton onClick={onExportClick}>
          <SvgIcon>
            <path d={mdiFileExcel} />
          </SvgIcon>
        </IconButton>
      </div>

      <FormControlLabel
        control={<Switch
          checked={expansionsToggled}
          onChange={onToggleExpansion}
          disabled={loading}
          color="primary"
        />}
        label="Expandir Todos"
      />
    </Grid>
  </Grid>;
}
